// In dev, use same-origin /api (proxied by craco to :8001). Set REACT_APP_BACKEND_URL for production.
const base = (process.env.REACT_APP_BACKEND_URL ?? '').replace(/\/$/, '');

export const API = base ? (base.endsWith('/api') ? base : `${base}/api`) : '/api';
